module.exports = __webpack_public_path__ + "img/Lego_Kids_sk.43bcb551.png";